<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2 mt-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-send</v-icon>
				営業に回答する
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white">
					工事引合依頼回答
				</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<v-form ref="form" v-model="valid">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :columnName="'回答内容'" :value="'XXXX'" />
							<ShowDetailRecord :columnName="'回答額'" :value="'XXX,XXX,XXX円'" />
							<ShowDetailRecord :columnName="'工事期間'" :value="'XX日間'" />
							<template v-if="costExists">
								<ShowDetailRecord :columnName="'見積金額'">
									<template v-slot:value>
										<v-text-field
											v-model="column1"
											background-color="white"
											dense
											outlined
											:rules="[rules.required]"
											hide-details
											:suffix="'円'"
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'見積工事期間'">
									<template v-slot:value>
										<v-text-field
											v-model="column2"
											background-color="white"
											dense
											outlined
											:rules="[rules.required]"
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</template>
						</tbody>
					</table>
				</v-form>
				<div v-if="answerExists" class="mt-4 mb-2">
					<p>腕に回答済みです。</p>
				</div>
				<div v-else-if="costExists" class="mt-4 mb-2">
					<p>上記の内容で回答します。<br />よろしいですか。</p>
					<v-row no-gutters justify="space-around">
						<v-btn class="mt-4" color="secondary" @click="submitForm">
							<v-icon class="mr-1">mdi-file-send-outline</v-icon>
							回答する
						</v-btn>
						<v-btn class="mt-4" @click="dialog = false"> キャンセル </v-btn>
					</v-row>
				</div>
				<div v-else class="mt-4 mb-2">
					<p>原価見積が作成されていません。</p>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		requirement: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			column1: 'XXXXXXXX', // RequirementColumn 名前変更要
			column2: 'XXXXX', // RequirementColumn 名前変更要
			costExists: true, // 原価見積があるかどうか propsで判定でも可
			answerExists: false, // 回答しているか propsで判定でも可
			dialog: false,
			rules,
			common,
		}
	},
	methods: {
		submitForm() {
			// 回答処理
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/requirements`
			const params = { requirement: this.newRequirement }
			axios
				.post(url, params, { headers })
				.then((res) => {
					// TODO
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$emit("submit-answer")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
